import CardSkelton from '@components/CardSkelton/CardSkelton';
import useInternalApplicationListData from 'modules/internalApplications/hooks/useInternalApplicationListData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import InternalApplicationCard from '../InternalApplicationCard/InternalApplicationCard';
import { CircularProgress } from '@hyperflake/react-ui-library';
import { IInternalApplications } from '@api/models';

interface IInternalApplicationListProps {
    interalApplicationData: IInternalApplications[];
}

const InternalApplicationsList = (props: IInternalApplicationListProps) => {
    const { interalApplicationData } = props;

    return (
        <>
            <div className="grid grid-cols-12 gap-6 mt-6 empty:hidden">
                {interalApplicationData.map((internalApplication, i) => (
                    <div key={i} className="col-span-12 md:col-span-6  lg:col-span-4">
                        <InternalApplicationCard data={internalApplication} />
                    </div>
                ))}
            </div>
        </>
    );
};

export default InternalApplicationsList;
